import {
  Card,
  CardBody,
  Stat,
  StatGroup,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react";
import { PreferredReturnSummaryData } from "gen/model/preferredReturnSummaryData";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  CardSection,
  CardSectionBody,
  CardSectionGroup,
} from "shared/components/card/CardSection";
import { EqualizedViewToggleButton } from "shared/components/toggle/EqualizedViewToggleButton";
import { formatIsoDateToSummary } from "shared/utils/DateUtils";

export const WaterfallPreferredReturnStats: React.FC<{
  data?: PreferredReturnSummaryData;
  isEqualizedView?: boolean;
  setIsEqualizedView?: (isEqualizedView: boolean) => void;
}> = ({ data, isEqualizedView, setIsEqualizedView }) => {
  const { t } = useTranslation(["distribution", "waterfall"]);
  if (!data) {
    return null;
  }
  return (
    <Card variant="stat" size="xs">
      <CardBody>
        <CardSectionGroup>
          <CardSection>
            <CardSectionBody>
              <StatGroup>
                <Stat size="xs">
                  <StatLabel>
                    {t("distribution:waterfallFund.distributionDate")}
                  </StatLabel>
                  <StatNumber>
                    {formatIsoDateToSummary(data.effective_date_of_event)}
                  </StatNumber>
                </Stat>
              </StatGroup>
            </CardSectionBody>
          </CardSection>
          {setIsEqualizedView && (
            <CardSection>
              <CardSectionBody>
                <StatGroup>
                  <EqualizedViewToggleButton
                    isEqualizedView={isEqualizedView || false}
                    setIsEqualizedView={setIsEqualizedView}
                    size="lg"
                    actualTooltip={t("waterfall:toolTips.actualToolTip")}
                    equalizedTooltip={t("waterfall:toolTips.equalizedToolTip")}
                  />
                </StatGroup>
              </CardSectionBody>
            </CardSection>
          )}
        </CardSectionGroup>
      </CardBody>
    </Card>
  );
};
